
import * as R from 'ramda';
import { version } from '~/../package.json';
import { DisabledError, InvalidHashError } from '~/errors';

// merge :: [Object] -> Object
/** @type {(values: InstanceSettings[]) => InstanceSettings} */
const merge = R.reduce(R.mergeDeepRight, {});

const defaults = {
  feature: {
    eventsAndNews: true,
    locations: {
      playTimeout: 3000,
      replayTimeout: 5000
    },
    openingHours: true,
    search: true,
    stores: {
      view: 'logo'
    },
    storeView: true,
    tipsAndBenefits: true,
    lunchMenu: false
  },
  timeouts: {
    player: '15s',
    session: '30s'
  }
};

/** @type {(hash: string) => Promise<InstanceSettings>} */
export const getImdSettings = (hash) => {
  const imdSettingsUrl = '/' + hash + '/imd-settings';

  return fetch(imdSettingsUrl)
    .then((response) => {
      if (!response.ok) throw new InvalidHashError(hash);
      return response.json();
    })
    .then((data) => {
      if (data.disabled) {
        throw new DisabledError(hash);
      }
      return data;
    })
    .then((data) => merge([
      defaults,
      data,
      depregateMenu(data),
      {
        genericConfigurations: {
          apiUrl: data.apiEndPoint,
          apiKey: data.apiKey,
          scid: data.scid,
          apiVersion: data.defaultApiVersion
        },
        screensaverOn: data.screensaver,
        disabledLanguages: getDisabledLanguages(data.disabledLanguages),
        thirdPartyLinks: data.thirdPartyLinks || [],
        isLandscape: !!data.isLandscape,
        scaleToScreen: !!data.scaleToScreen,
        integration: data.integration || {},
        mapType: { [data.mapType || 'inhouse']: true },
        version
      }
    ])
    );
};

const depregateMenu = ({ menu }) => {
  if (menu) {
    console.warn(`Depracated IMD setting 'menu'. Use 'feature' instead.`);
    return { feature: menu };
  }
  return {};
};

export const getDisabledLanguages = (commaSeparatedStringOfLanguages = '') => {
  return commaSeparatedStringOfLanguages
    .replace(/\s/g, '')
    .split(',')
    .filter(elem => elem.length > 0);
};

// getImdVersion :: () -> String
export const getImdVersion = () => version;
